/**
 * @generated SignedSource<<9f2a550ab2cc7c2e7d72911c750e465f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TransportationCode = "CADDIE" | "CADDIE_CART" | "CART" | "FULL_CART" | "MOTOR_PULL_CART" | "PRIVATE_CART" | "PULL_CART" | "SINGLE_CART" | "WALK";
export type VisibilityStatus = "ALL" | "NONE" | "QUALIFYING";
import { FragmentRefs } from "relay-runtime";
export type BundledTransportationTypeSelectNode$data = {
  readonly rates: ReadonlyArray<{
    readonly eighteenHolePrice: number | null | undefined;
    readonly nineHolePrice: number | null | undefined;
    readonly rate: {
      readonly appliesToMembershipType: boolean | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly visibility: VisibilityStatus;
    };
  } | null | undefined> | null | undefined;
  readonly transportationTypes: ReadonlyArray<{
    readonly code: TransportationCode | null | undefined;
    readonly customCode: string | null | undefined;
    readonly eighteenHolePrice: number | null | undefined;
    readonly enabled: boolean;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly nineHolePrice: number | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "BundledTransportationTypeSelectNode";
};
export type BundledTransportationTypeSelectNode$key = {
  readonly " $data"?: BundledTransportationTypeSelectNode$data;
  readonly " $fragmentSpreads": FragmentRefs<"BundledTransportationTypeSelectNode">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "NINE"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "holeCount",
    "value": "EIGHTEEN"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "memberId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "membershipTypeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BundledTransportationTypeSelectNode",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "memberId",
          "variableName": "memberId"
        },
        {
          "kind": "Literal",
          "name": "memberVisible",
          "value": true
        }
      ],
      "concreteType": "TransportationType",
      "kind": "LinkedField",
      "name": "transportationTypes",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customCode",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": "nineHolePrice",
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"NINE\")"
        },
        {
          "alias": "eighteenHolePrice",
          "args": (v3/*: any*/),
          "kind": "ScalarField",
          "name": "totalPrice",
          "storageKey": "totalPrice(holeCount:\"EIGHTEEN\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "rates",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "CUSTOMER"
        },
        {
          "kind": "Variable",
          "name": "visibleToMembershipTypeId",
          "variableName": "membershipTypeId"
        }
      ],
      "concreteType": "SlotRate",
      "kind": "LinkedField",
      "name": "playerRates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "rate",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "membershipTypeId",
                  "variableName": "membershipTypeId"
                }
              ],
              "kind": "ScalarField",
              "name": "appliesToMembershipType",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "nineHolePrice",
          "args": (v2/*: any*/),
          "kind": "ScalarField",
          "name": "totalGolfPrice",
          "storageKey": "totalGolfPrice(holeCount:\"NINE\")"
        },
        {
          "alias": "eighteenHolePrice",
          "args": (v3/*: any*/),
          "kind": "ScalarField",
          "name": "totalGolfPrice",
          "storageKey": "totalGolfPrice(holeCount:\"EIGHTEEN\")"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Slot",
  "abstractKey": "__isSlot"
};
})();

(node as any).hash = "1bdea48ba8a5a7eb092cbd79176b0bac";

export default node;
